
import ModelService from "@/service/ModelService";
 
class IndexModel extends ModelService { 
     
    
    protected  url_consulta = ''; 
    protected  secret_key = 'asdl3@123ag0LFe23v'; 
    
    constructor() {
        super();
        this.url = this.versao + '/admin' ; 
        this.url_consulta = this.versao + '/consulta' ;
    }
     
    public getUrlConsulta( ) { 
        return  this.url_consulta; 
    }
 
    public getKeyCripto( ) { 
        return  this.secret_key; 
    }
     
    public cadastrar(   dados: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url   , dados   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public excluir( id: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().delete( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public update( id: any , dados: any ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/' + id   , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    

    
    public getAll( params: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().get( this.url + `?${params}` )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
}
 

export default IndexModel;

